// Non-actionable error noise — dropped before being recorded (see gatsby-browser.js loadDataDog beforeSend).
// Mirrors hb-webflow/src/constants/errors.ts so both marketing bundles
// (service:gatsby-marketing-site and service:webflow) suppress the same noise.

export const EXPECTED_ERROR_NOISE = [
    'Error retrieving a token', // FedCM token-retrieval failures (no Google session / dismissed / cooldown)
    'The browser is not supported', // GSI: browser lacks One Tap / FedCM support — unactionable
    'does not support public key credentials', // GSI NotSupportedError on browsers without FedCM — unactionable
    'Check credential status returns invalid response', // GSI: transient Google-side credential-status response — unactionable
    'navigator.credentials.get request may be outstanding', // FedCM lifecycle collision (GIS reprompt / bf-nav) — unactionable
    'Invalid call to runtime.sendMessage' // WebExtension messaging error thrown by a visitor's Safari Web Extension content script (frameless stack, fires only while page is backgrounded, Safari/iOS-only) — not HoneyBook code; ~20k/30d on this app — unactionable
];

export const EXTENSION_STACK_NOISE = ['chrome-extension://', 'moz-extension://', 'safari-extension://'];
